import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TimeSlotButtonProps {
  time: string; // Display time (e.g., "9:00 AM")
  isSelected?: boolean;
  isDisabled?: boolean;
  onClick: () => void;
  className?: string;
}

export const TimeSlotButton: React.FC<TimeSlotButtonProps> = ({
  time,
  isSelected = false,
  isDisabled = false,
  onClick,
  className,
}) => {
  return (
    <Button
      type="button"
      variant={isSelected ? 'default' : 'outline'}
      onClick={onClick}
      disabled={isDisabled}
      className={cn(
        'rounded-lg px-4 py-2 h-11 text-sm font-medium transition-all w-full',
        isSelected
          ? 'bg-teal-600 text-white hover:bg-teal-700 shadow-md'
          : 'border-slate-200 text-slate-700 hover:border-teal-300 hover:bg-teal-50 hover:text-teal-700',
        isDisabled && 'opacity-50 cursor-not-allowed',
        className
      )}
    >
      {time}
    </Button>
  );
};

interface TimeSlotGridProps {
  slots: Array<{
    start: string;
    displayTime: string;
  }>;
  selectedSlot?: string;
  onSelectSlot: (slotStart: string) => void;
  loading?: boolean;
  emptyMessage?: string;
  className?: string;
}

export const TimeSlotGrid: React.FC<TimeSlotGridProps> = ({
  slots,
  selectedSlot,
  onSelectSlot,
  loading = false,
  emptyMessage = 'No available times for this date',
  className,
}) => {
  if (loading) {
    return (
      <div className={cn('grid grid-cols-2 sm:grid-cols-3 gap-2.5', className)}>
        {Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="h-11 rounded-lg bg-slate-100 animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (slots.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500">
        <p>{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={cn('grid grid-cols-2 sm:grid-cols-3 gap-2.5', className)}>
      {slots.map((slot) => (
        <TimeSlotButton
          key={slot.start}
          time={slot.displayTime}
          isSelected={selectedSlot === slot.start}
          onClick={() => onSelectSlot(slot.start)}
        />
      ))}
    </div>
  );
};

export default TimeSlotButton;






